// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useContextMenu } from "./SectionContainer"


interface KnowledgeBaseLinkProps {
  children: React.ReactNode
  doc: string
}


const KnowledgeBaseLink: React.FC<KnowledgeBaseLinkProps> = ({children, doc}) => {
  const ctx = useContextMenu()

  const onClick: () => void = () => {
    if (ctx.helpArticle !== doc) {
      ctx.setHelpArticle(doc)
    } else {
      ctx.setHelpArticle(null)
    }
  }

  return (
    <div onClick={onClick}>{children}</div>
  )
}


export { KnowledgeBaseLink }